/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateCustomFieldDefinitionInput = {
    id?: string | null | undefined;
    displayName?: string | null | undefined;
    readOnly?: boolean | null | undefined;
    avaRef?: number | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UpdateCustomFieldDefinitionMutationVariables = {
    input: UpdateCustomFieldDefinitionInput;
};
export type UpdateCustomFieldDefinitionMutationResponse = {
    readonly updateCustomFieldDefinition: {
        readonly customFieldDefinition: {
            readonly node: {
                readonly id: string;
                readonly key: string | null;
                readonly type: string | null;
                readonly displayName: string | null;
                readonly readOnly: boolean | null;
                readonly entityType: string | null;
                readonly avaRef: number | null;
            } | null;
        } | null;
    } | null;
};
export type UpdateCustomFieldDefinitionMutation = {
    readonly response: UpdateCustomFieldDefinitionMutationResponse;
    readonly variables: UpdateCustomFieldDefinitionMutationVariables;
};



/*
mutation UpdateCustomFieldDefinitionMutation(
  $input: UpdateCustomFieldDefinitionInput!
) {
  updateCustomFieldDefinition(input: $input) {
    customFieldDefinition {
      node {
        id
        key
        type
        displayName
        readOnly
        entityType
        avaRef
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCustomFieldDefinitionInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "updateCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDefinitionTypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readOnly",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avaRef",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UpdateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCustomFieldDefinitionMutation(\n  $input: UpdateCustomFieldDefinitionInput!\n) {\n  updateCustomFieldDefinition(input: $input) {\n    customFieldDefinition {\n      node {\n        id\n        key\n        type\n        displayName\n        readOnly\n        entityType\n        avaRef\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '1b6fd2de4280061dc32d3279add8d7cf';
export default node;
